import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { CheckCircleOutlineOutlined } from '@mui/icons-material';
import Container from '../../components/LandingPage/Container';

const VantageCard: React.FC<{ title: string; description: string }> = ({ title, description }) => {
  return (
    <Box
      height={{ xs: '100%', md: '186px' }}
      display="flex"
      flexDirection="column"
      gap="11px"
      padding="21px 11px"
      bgcolor="var(--acer-green)"
    >
      <CheckCircleOutlineOutlined width="24px" height="24px" sx={{ color: 'var(--acer-dark)' }} />
      <Typography
        color="white"
        fontSize="16px"
        fontWeight="500"
        lineHeight="24px"
        letterSpacing="0.15px"
      >
        {title}
      </Typography>
      <Typography
        color="white"
        fontSize="16px"
        fontWeight="400"
        lineHeight="24px"
        letterSpacing="0.15px"
      >
        {description}
      </Typography>
    </Box>
  );
};

const Vantages: React.FC = () => {
  const vantageCards = [
    {
      title: 'Ótimo custo-benefício',
      description: 'Equipamentos competitivos que entregam bom desempenho por preços acessíveis.',
    },
    {
      title: 'Ampla variedade',
      description: 'Linha diversificada de notebooks, desktops e monitores para diferentes perfis.',
    },
    {
      title: 'Tecnologia atual',
      description: 'Produtos com processadores modernos e recursos alinhados às demandas atuais.',
    },
    {
      title: 'Boa confiabilidade',
      description:
        'Marca consolidada mundialmente com histórico consistente de qualidade e suporte.',
    },
  ];

  return (
    <Box bgcolor="var(--acer-dark)" padding="41px 0">
      <Container>
        <Box display="flex" flexDirection="column" gap="29px" width="100%">
          <Typography
            color="white"
            fontSize="28px"
            fontWeight="400"
            lineHeight="36px"
            letterSpacing="0"
          >
            Por que escolher Acer
          </Typography>
          <Grid container spacing="29px">
            {vantageCards.map(vantageCard => (
              <Grid item xs={12} md={6} key={vantageCard.title}>
                <VantageCard
                  key={vantageCard.title}
                  title={vantageCard.title}
                  description={vantageCard.description}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default Vantages;
